/* src/app/pages/casos/verarchivos/verarchivos.component.scss */
/*# sourceMappingURL=verarchivos.component.css.map */
